<template>
  <div class="centerIntro-wrap">
    <div class="centerIntro-content">
      <div class="title">中心简介</div>
      <div class="content" v-html="content"></div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      content: ''
    }
  },
  mounted(){
    this.getDetail()
  },
  methods:{
    getDetail(){
      let code = this.$route.query.code
      this.$store.dispatch('articleDetail/getHomeList',{code}).then(res=>{
          this.$store.dispatch('articleDetail/getDetail',{id: res.rows[0].id}).then(ele=>{
            this.content = ele.data.content
          })
      })
      
    }
  } 
}
</script>

<style>
</style>
